import { useCallback, useId } from "react";
import { useFormContext } from "react-hook-form";

export const useUnsavedMarker = (key: string) => {
  const { setValue, getValues, getFieldState, unregister } = useFormContext<Record<string, string>>() ?? {};
  // The marker holds the id of the mount that set it, so a save finishing after its input
  // remounted (e.g. switching signature method and back) can't clear the new mount's marker.
  const owner = useId();

  const mark = () => setValue?.(key, owner, { shouldDirty: true });
  const clear = useCallback(() => {
    if (getFieldState?.(key).isDirty && getValues?.(key) === owner) unregister?.(key);
  }, [getFieldState, getValues, unregister, key, owner]);

  return { mark, clear };
};
